import { useEffect, useState } from 'react';
import { AdminAuth } from '../../auth';
import { useNavigate } from 'react-router-dom';
import '../../styles/admin/AdminLogin.css';

export default function AdminLogin() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const handleAuthChange = (authUser) => {
    setUser(authUser);
    if (authUser) {
      console.log('Admin authenticated:', authUser.email);
      navigate('/admin/dashboard');
    }
  };

  // If user is already authenticated, redirect immediately
  useEffect(() => {
    if (user) {
      navigate('/admin/dashboard');
    }
  }, [user, navigate]);

  // Don't render anything if user is authenticated (will redirect)
  if (user) return null;

  return (
    <div className="admin-login-container">
      <AdminAuth 
        onAuthChange={handleAuthChange}
        // Uncomment the line below if you want to restrict admin access to specific domains
        // allowedDomains={['nhh.no']} // Only allow NHH email addresses
      />
    </div>
  );
}